export enum CopyWekalaTypeEnum {
  CopyWekalaSecondParties = 1,
  CopyWekalaFirstParties = 3,
  CopyWekalaClauses = 2,
}
